(() => {
  if (window.Koko15) return;
  const code = 'KOKO15';
  const title = (entry) => String(entry.discount_application?.title || entry.title || '').toUpperCase();
  function classify(cart) {
    if (!cart.item_count) return 'empty';
    const codes = cart.discount_codes || [];
    const allocations = [...(cart.cart_level_discount_applications || []), ...(cart.items || []).flatMap(item => item.discounts || [])];
    if (codes.some(entry => entry.code.toUpperCase() !== code) || allocations.some(entry => entry.amount > 0 && title(entry) !== code)) return 'protected';
    const selected = codes.find(entry => entry.code.toUpperCase() === code);
    if (selected?.applicable === false) return 'unavailable';
    if (selected?.applicable && allocations.some(entry => title(entry) === code && entry.amount > 0)) return 'applied';
    return 'pending';
  }
  window.Koko15 = { classify };
  if (typeof document === 'undefined') return;
  const config = document.querySelector('[data-koko15-config]');
  if (!config) return;
  const messages = JSON.parse(config.textContent);
  const root = window.Shopify?.routes?.root || '/';
  let running;
  let queued = false;
  let timer;
  let lastAttempt = '';
  const money = (amount, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(amount / 100);
  const propertyPairs = properties => JSON.stringify((Array.isArray(properties) ? [...properties] : Object.entries(properties || {})).sort());
  const cartBusy = () => document.querySelector('.cart__items--disabled, product-form[aria-busy="true"]') || (typeof kokoCartEditUpdating !== 'undefined' && kokoCartEditUpdating);
  function render(cart, state) {
    document.querySelectorAll('[data-cart-coupon], [data-cart-page-coupon]').forEach(panel => {
      if (!panel.querySelector('[data-koko15-status]')) panel.innerHTML = '<p data-koko15-status role="status"></p>';
      const status = panel.querySelector('[data-koko15-status]');
      status.textContent = messages[state] || messages.pending;
      panel.dataset.koko15State = state;
    });
    if (!cart) {
      document.querySelectorAll('[data-koko15-price], [data-koko15-line-total]').forEach(el => el.remove());
      document.querySelectorAll('[data-koko15-original-price], .cart-item__price-wrapper > [hidden]').forEach(el => { el.hidden = false; el.style.removeProperty('display'); });
      return;
    }
    const format = amount => money(amount, cart.currency);
    document.querySelectorAll('.totals__total-value, .koko-cart-summary__mobile-total strong').forEach(el => { el.textContent = format(cart.total_price); });
    document.querySelectorAll('[data-koko-cart-free-shipping], [data-koko-cart-ship]').forEach(el => {
      el.textContent = cart.currency === 'USD' && messages.shipping_remaining
        ? (cart.total_price >= 4900 ? messages.shipping_reached : messages.shipping_remaining.replace('__AMOUNT__', format(4900 - cart.total_price)))
        : messages.shipping;
    });
    (cart.items || []).forEach((item) => {
      const discount = (item.discounts || []).reduce((sum, entry) => sum + Number(entry.amount || 0), 0);
      const net = item.original_line_price - discount;
      document.querySelectorAll('[data-koko15-identity]').forEach(row => {
        const [variant, properties, sellingPlan] = JSON.parse(row.dataset.koko15Identity);
        if (variant !== item.variant_id || propertyPairs(properties) !== propertyPairs(item.properties) || sellingPlan !== (item.selling_plan_allocation?.selling_plan?.id || null) || Number(row.dataset.koko15Quantity) !== item.quantity) return;
        const details = row.querySelector('.cart-item__details');
        if (!details) return;
        let price = details.querySelector('[data-koko15-price]');
        if (!price) {
          price = document.createElement('p');
          price.dataset.koko15Price = '';
          details.querySelector('.cart-item__name')?.after(price);
        }
        details.querySelectorAll('[data-koko15-original-price]').forEach(el => { el.hidden = true; el.style.setProperty('display', 'none', 'important'); });
        price.replaceChildren();
        const current = document.createElement('strong');
        current.textContent = (item.quantity > 1 ? messages.line_total + ': ' : '') + format(net);
        price.append(current);
        if (discount > 0) {
          const original = document.createElement('s');
          original.textContent = ' ' + format(item.original_line_price);
          price.append(original);
        }
        row.querySelectorAll('.cart-item__price-wrapper').forEach(wrapper => {
          Array.from(wrapper.children).filter(el => !el.matches('[data-koko15-line-total], .unit-price')).forEach(el => { el.hidden = true; el.style.setProperty('display', 'none', 'important'); });
          let total = wrapper.querySelector('[data-koko15-line-total]');
          if (!total) {
            total = document.createElement('span');
            total.dataset.koko15LineTotal = '';
            total.className = 'price price--end';
            wrapper.append(total);
          }
          total.textContent = format(net);
        });
      });
    });
  }
  async function request(path, body) {
    const response = await fetch(root + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
      signal: AbortSignal.timeout(8000),
    });
    if (!response.ok) throw new Error('Cart unavailable');
    return response.json();
  }
  async function update() {
    try {
      if (cartBusy()) { schedule(); return; }
      let cart = await request('cart.js');
      if (cartBusy()) { schedule(); return; }
      let state = classify(cart);
      const fingerprint = JSON.stringify([cart.items.map(item => [item.key, item.quantity]), cart.discount_codes, cart.currency]);
      if (state === 'pending' && fingerprint !== lastAttempt) {
        lastAttempt = fingerprint;
        render(cart, 'pending');
        await request('cart/update.js', { discount: code });
        cart = await request('cart.js');
        state = classify(cart);
      }
      if (cartBusy()) schedule();
      else render(cart, state);
    } catch {
      render(null, 'pending');
    } finally {
      running = null;
      if (queued) { queued = false; schedule(); }
    }
  }
  function sync() {
    clearTimeout(timer);
    if (running) return running;
    running = Promise.resolve().then(update);
    return running;
  }
  window.Koko15.sync = sync;
  window.Koko15.beforeCheckout = async () => {
    const deadline = Date.now() + 8000;
    while (cartBusy() && Date.now() < deadline) await new Promise(resolve => setTimeout(resolve, 100));
    if (cartBusy()) return false;
    if (running) await running;
    await sync();
    return true;
  };
  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 100); }
  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
    if (running) queued = true;
    else schedule();
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    const button = event.submitter;
    if (button?.name !== 'checkout') return;
    event.preventDefault();
    if (form.dataset.koko15Checking) return;
    form.dataset.koko15Checking = 'true';
    try {
      if (!await window.Koko15.beforeCheckout()) return;
      window.location.assign(root + 'checkout');
    } finally {
      delete form.dataset.koko15Checking;
    }
  }, true);
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('cart-drawer-items, .cart-item, [data-cart-coupon], [data-cart-page-coupon]') || node.querySelector?.('.cart-item'))))) schedule();
  }).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('pageshow', schedule);
  schedule();
})();
